export class DriveChoiceStat {
    drive_choice: number;
    count: number;
}

export class UserStats {
    drive_choices: DriveChoiceStat[];
}
